import React from 'react';
import { motion } from 'framer-motion';

const MenuButton = ({ isOpen, clickHandler }) => {
	const variant = isOpen ? 'opened' : 'closed';
	const top = {
		closed: {
			rotate: 0,
			translateY: 0,
		},
		opened: {
			rotate: 45,
			translateY: 2,
		},
	};

	const center = {
		closed: {
			opacity: 1,
		},
		opened: {
			opacity: 0,
		},
	};

	const bottom = {
		closed: {
			rotate: 0,
			translateY: 0,
		},
		opened: {
			rotate: -45,
			translateY: -2,
		},
	};

	const lineProps = {
		stroke: 'white',
		strokeWidth: 1,
		vectorEffect: 'non-scaling-stroke',
		initial: 'closed',
		animate: variant,
	};

	const unitHeight = 4;
	const unitWidth = (unitHeight * 24) / 24;

	return (
		<motion.svg
			onClick={clickHandler}
			className="cursor-pointer"
			viewBox={`0 0 ${unitWidth} ${unitHeight}`}
			overflow="visible"
			preserveAspectRatio={'none'}
			width={24}
			height={24}
		>
			<motion.line
				x1="0"
				x2={unitWidth}
				y1="0"
				y2="0"
				variants={top}
				{...lineProps}
			/>
			<motion.line
				x1="0"
				x2={unitWidth}
				y1="2"
				y2="2"
				variants={center}
				{...lineProps}
			/>
			<motion.line
				x1="0"
				x2={unitWidth}
				y1="4"
				y2="4"
				variants={bottom}
				{...lineProps}
			/>
		</motion.svg>
	);
};

export default MenuButton;
